import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Navigation: React.FC = () => {
  const location = useLocation();
  const { authState, logout } = useAuth();
  const { isAuthenticated, isLoading } = authState;
  
  // Check if a link is active
  const isActive = (path: string) => location.pathname === path;

  // Handle logout
  const handleLogout = async (e: React.MouseEvent) => {
    e.preventDefault();
    try {
      await logout();
      // Redirect will happen automatically through AuthenticatedRoute component
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  return (
    <nav className="navigation">
      <div className="nav-logo">
        <span>Location Tracker</span>
      </div>
      <div className="nav-links">
        {/* Always visible links */}
        <Link to="/" className={`nav-link ${isActive('/') ? 'active' : ''}`}>Map</Link>
        
        {/* Authenticated-only links */}
        {isAuthenticated && !isLoading && (
          <>
            <Link to="/objects" className={`nav-link ${isActive('/objects') ? 'active' : ''}`}>Objects</Link>
            <Link to="/geofences" className={`nav-link ${isActive('/geofences') ? 'active' : ''}`}>Geofences</Link>
            <Link to="/test-tools" className={`nav-link ${isActive('/test-tools') ? 'active' : ''}`}>Test Tools</Link>
            <button className="nav-link auth-link logout-button" onClick={handleLogout}>Logout</button>
          </>
        )}
        
        {/* Unauthenticated-only links */}
        {!isAuthenticated && !isLoading && (
          <>
            <Link to="/login" className={`nav-link auth-link ${isActive('/login') ? 'active' : ''}`}>Login</Link>
            <Link to="/signup" className={`nav-link auth-link ${isActive('/signup') ? 'active' : ''}`}>Sign Up</Link>
          </>
        )}
      </div>
    </nav>
  );
};

export default Navigation;
